import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { Options } from '@angular-slider/ngx-slider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EnumSectionStatus, IQuestionnaireQuestion, IQuestionnaireSection, IQuestionnaireSubSection } from '../questionnaire.model';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: `app-scale-slider`,
    standalone: true,
    imports: [
        CommonModule,
        NgxSliderModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: `./scale-slider.component.html`,
    styleUrls: ['./scale-slider.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ScaleSliderComponent implements OnInit {
    @Input() section: IQuestionnaireSection;
    @Input() subSection: IQuestionnaireSubSection;
    @Input() question: IQuestionnaireQuestion;

    @Input() sliderId: string = new Date().getTime().toString();

    sliderControl: UntypedFormControl = new UntypedFormControl(0);
    currentScale: number = 0;
    @Output() scaleChange = new EventEmitter<number>();

    get isDisalbed() {
        return this.subSection.status == EnumSectionStatus.COMPLETED ? true : false;
    }

    get sliderOptions(): Options {
        return {
            floor: this.question?.scaleOption.floor,
            ceil: this.question?.scaleOption.ceil,
            step: this.question?.scaleOption.step,
            showSelectionBar: true,
            disabled: this.isDisalbed,
            translate: (value: number): string => {
                return value + `${this.question?.scaleOption.translate || ''}`;
            }
        }
    };


    ngOnInit(): void {
        this.fnSetSliderValue();
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                this.fnSetSliderValue();
            }
        }
    }

    fnSetSliderValue() {
        this.sliderControl.setValue(this.question.answer.value);
    }

    onUserChange(event) {
        if (this.isDisalbed) {
            return;
        }
        this.question.hasError = false;
        this.scaleChange.emit(event.value);
    }
}
